import { useMutation, useQueryClient } from '@tanstack/react-query'
import { toast } from 'react-toastify'

import { axiosInstance } from '../../helpers'
import { Lead } from '../../models/Outreach/types'
import { GuestCardFormRequest } from './useGuestCardForm'

export type SubmitLeadGuestCardRequest = GuestCardFormRequest & {
    guest_card_id: number
}

export const useSubmitLeadGuestCard = () => {
    const queryClient = useQueryClient()

    const submitLeadGuestCard = useMutation({
        mutationFn: async ({
            leadId,
            payload,
        }: {
            leadId: number
            payload: SubmitLeadGuestCardRequest
        }) => {
            const { data } = await axiosInstance.post<Lead>(
                `/outreach/leads/${leadId}/submit-guest-card/`,
                payload,
            )
            return data
        },
        onSuccess: async () => {
            await Promise.all([
                queryClient.invalidateQueries({
                    queryKey: ['leads'],
                    exact: false,
                }),
                queryClient.invalidateQueries({
                    queryKey: ['apartment-tours'],
                    exact: false,
                }),
                queryClient.invalidateQueries({
                    queryKey: ['leasing-season-pipeline-counts'],
                    exact: false,
                }),
            ])
            toast.success('Guest card submitted successfully')
        },
        onError: (error: { response?: { data?: { error?: string } } }) => {
            toast.error(
                error?.response?.data?.error ?? 'Failed to submit guest card',
            )
        },
    })

    return {
        submitLeadGuestCard: submitLeadGuestCard.mutateAsync,
        isSubmitting: submitLeadGuestCard.isLoading,
        reset: submitLeadGuestCard.reset,
    }
}
